// use the amplify API to make a request against quizRestAPI /public/hubspot with the user object

//import { API } from 'aws-amplify';
import Cookies from 'js-cookie';
import { User } from '../types';
import { getUTMParams } from '../utils';

// Read identity + attribution cookies set by App.tsx (Amplitude device ID,
// UTM cookies). Returns only the keys that have values so we don't overwrite
// existing Hubspot contact properties with empty strings on repeat submits.
const getAttributionFields = (): Record<string, string> => {
  const fields: Record<string, string> = {};
  const amplitudeId = Cookies.get('bws_amplitude_device_id');
  if (amplitudeId) fields.amplitudeId = amplitudeId;
  const utm = getUTMParams();
  if (utm) {
    if (utm.utm_source) fields.utm_source = utm.utm_source;
    if (utm.utm_medium) fields.utm_medium = utm.utm_medium;
    if (utm.utm_campaign) fields.utm_campaign = utm.utm_campaign;
    if (utm.utm_term) fields.utm_term = utm.utm_term;
    if (utm.utm_content) fields.utm_content = utm.utm_content;
  }
  return fields;
};
/*
export const submitUserToHubspot = async (user: User, complete: boolean) => {
  return await API.post('quizRestAPI', '/public/hubspot/create-user', {
    body: { ...user, complete }
  });
}

export const saveTimeToGoalToHubspot = async (user: User, timeToGoal: number) => {
  const complete: boolean = true;
  return await API.post('quizRestAPI', '/public/hubspot/save-goal-time', {
    body: { ...user,complete,timeToGoal }
  });
}

*/
export type UserHubspotResponse = {
  userId: string;
};


export const submitUserToHubspot = async (user: User, complete: boolean) => {
  const response = await fetch('https://api.builtwithscience.com/production/gateway/v2/hubspot/create-user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...user, complete, ...getAttributionFields() })
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data: UserHubspotResponse = await response.json();
    return data.userId;
}

export const saveTimeToGoalToHubspot = async (user: User, timeToGoal: number) => {
  const complete = true;
  const response = await fetch('https://api.builtwithscience.com/production/gateway/v2/hubspot/save-goal-time', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...user,
      weight: {
        weightRaw: user.weight,
      },
      goalWeight: {
        goalWeightRaw: user.goalWeight,
      },
      complete,
      timeToGoal,
      ...getAttributionFields(),
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data: UserHubspotResponse = await response.json();
  return data.userId;
}


